export default __webpack_public_path__ + "static/media/como_te_enteraste.a30b6884.svg";